export default {
	type: 'boolean',
}
